var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBhSkhoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2769 12.6066C33.2769 16.9959 30.7959 21.5 25.9039 26.0041C23.6825 28.0477 21.2638 29.8548 18.6851 31.3976C18.5176 31.4917 18.3296 31.5411 18.1384 31.5411C17.9473 31.5411 17.7593 31.4917 17.5918 31.3976C16.989 31.0533 3 22.9201 3 12.6066C3 10.8002 3.55539 9.03962 4.5875 7.57422C5.61961 6.10882 7.07611 5.01288 8.75069 4.44166C10.4253 3.87044 12.233 3.85288 13.9179 4.39148C15.6028 4.93008 17.0793 5.99753 18.1384 7.44263C19.1975 5.99753 20.6741 4.93008 22.359 4.39148C24.0438 3.85288 25.8516 3.87044 27.5262 4.44166C29.2008 5.01288 30.6573 6.10882 31.6894 7.57422C32.7215 9.03962 33.2769 10.8002 33.2769 12.6066Z",
    fill: "#1A427D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6992 16.4207L27.3539 13.8359L36.0003 16.4207V21.7214C36.0003 27.2928 32.5161 32.2389 27.351 34.0001C22.1845 32.239 18.6992 27.2917 18.6992 21.7189V16.4207Z",
    fill: "white",
    stroke: "#FB7800",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0239 23.1802L26.388 26.6228L32.155 20.7212",
    stroke: "#FB7800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhSkhoe);
export default __webpack_public_path__ + "static/media/bh-skhoe.9205de1c9b1581b822c69ceb26971f3f.svg";
export { ForwardRef as ReactComponent };